import React, { useMemo, useState } from 'react';
import styles from './DirectorySection.module.css';
import DirectoryTree from './DirectoryTree';
import DirectoryContent from './DirectoryContent';
import directoryData from './directoryData';

// Directory navigation, two-column (Miller) model:
//   - DirectoryTree renders two side-by-side columns — top-level folders on the
//     left, the active folder's children on the right (it owns the active
//     folder internally; no inline expansion).
//   - Clicking a child fires onSelect(leafKey); the [FIG. 2] frame on the far
//     right swaps to that leaf's body.
// Pure in-page state — no routing, no URL change.
//
// Mobile decision: at < 768px everything stacks vertically — folders, then
// children (handled inside DirectoryTree), then the [FIG. 2] frame — rather
// than a drill-in pattern. The stack is simpler, keeps the full path visible
// while scanning, and matches the sketch. Drill-in remains a possible
// follow-up if the stack proves too tall in practice.

function findLeaf(key) {
  if (!key) return null;
  for (const folder of directoryData) {
    const leaf = folder.children.find((child) => child.key === key);
    if (leaf) return leaf;
  }
  return null;
}

function DirectorySection() {
  const [selectedLeafKey, setSelectedLeafKey] = useState(null);
  const selectedLeaf = useMemo(
    () => findLeaf(selectedLeafKey),
    [selectedLeafKey]
  );

  return (
    <div className={styles.panes}>
      <div className={styles.treePane}>
        <DirectoryTree
          data={directoryData}
          selectedKey={selectedLeafKey}
          onSelect={setSelectedLeafKey}
        />
      </div>
      <div className={styles.contentPane}>
        <DirectoryContent selectedLeaf={selectedLeaf} />
      </div>
    </div>
  );
}

export default DirectorySection;
